angular
	.module 'App.Filter'
	.filter 'layoutItemsByPage', () ->
		return (folder) ->
			currentPage = _.find folder.pages, {page_number: folder.current_page}

			return currentPage.items if currentPage
			return []
